import React from "react";
import { BarChart, Bar, ResponsiveContainer, YAxis, XAxis } from "recharts";

const CustomBarChart = ({ data }) => {
  // data = [{ name: "Economy", uv: 20000 }, ...]

  return (
    <div style={{ width: "100%", height: 250 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data || []}>
          <YAxis
            ticks={[0, 10000, 20000, 30000]}
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) => (value === 0 ? "0" : `${value / 1000}K`)}
            tick={{
              fontFamily: "Be Vietnam Pro",
              fontWeight: 400,
              fontSize: 12,
              lineHeight: 18,
              letterSpacing: 0,
              textAnchor: "middle",
            }}
          />
          <XAxis
            dataKey="name"
            interval={0}
            axisLine={false}
            tickLine={false}
            tick={{
              fontFamily: "Be Vietnam Pro",
              fontWeight: 400,
              fontSize: 13,
              lineHeight: 20,
              letterSpacing: 0,
              textAnchor: "middle",
            }}
          />
          <Bar dataKey="uv" fill="var(--primary-color)" radius={[8, 8, 8, 8]} barSize={80} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomBarChart;